// extracted by mini-css-extract-plugin
export default {"root":"classes_root__dOViH","checkbox":"classes_checkbox__ptFbU","unchecked-icon":"classes_unchecked-icon__eb61X","checked-icon":"classes_checked-icon__FB0d-"};